import { render } from "./UploadExcelBtn.vue?vue&type=template&id=5193e48d&scoped=true"
import script from "./UploadExcelBtn.vue?vue&type=script&lang=js"
export * from "./UploadExcelBtn.vue?vue&type=script&lang=js"

import "./UploadExcelBtn.vue?vue&type=style&index=0&id=5193e48d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5193e48d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
